// API Configuration
export const API_CONFIG = {
  // Pango API
  PANGO: {
    BASE_URL: process.env.REACT_APP_PANGO_API_BASE_URL || '',
    API_KEY: process.env.REACT_APP_PANGO_API_KEY || '',
    ENDPOINTS: {
      AUTH: {
        LOGIN: '/v1/auth/outlet/login',
        LOGOUT: '/v1/auth/outlet/logout',
        VALIDATE: '/v1/auth/outlet/validate'
      },
      ORDERS: {
        GET_ORDERS: '/v1/ai/smart-order/outlet/{outletId}/orders',
        GET_ORDER_DETAILS: '/v1/ai/smart-order/outlet/{outletId}/orders/{orderId}'
      },
      MISSIONS: {
        GET_MISSIONS: '/v1/ai/missions-engine/suggestions/{outletId}'
      },
      PROMOTIONS: {
        GET_PROMOTIONS: '/v1/catalog/promotions',
        GET_TRENDING_PRODUCTS: '/v1/catalog/products/trending'
      }
      // TODO: Add other endpoints when implementing
      // PRODUCTS: '/v1/products',
      // OUTLETS: '/v1/outlets'
    }
  },
  
  // AgentFlow AI Agent
  AGENTFLOW: {
    BASE_URL: process.env.REACT_APP_AGENTFLOW_API_BASE_URL || '',
    FLOW_ID: process.env.REACT_APP_AGENTFLOW_FLOW_ID || '',
    API_KEY: process.env.REACT_APP_AGENTFLOW_API_KEY || '',
    ENDPOINTS: {
      PREDICTION: '' // Base URL already includes the endpoint
    }
  },
  
  // App Configuration
  APP: {
    NAME: process.env.REACT_APP_APP_NAME || 'Pango Smart Outlet',
    VERSION: process.env.REACT_APP_APP_VERSION || '1.0.0',
    DEBUG: process.env.REACT_APP_DEBUG === 'true'
  }
};

// Validation functions
export const validateConfig = () => {
  const errors: string[] = [];
  
  if (!API_CONFIG.PANGO.BASE_URL) {
    errors.push('REACT_APP_PANGO_API_BASE_URL is required');
  }
  
  if (!API_CONFIG.PANGO.API_KEY) {
    errors.push('REACT_APP_PANGO_API_KEY is required');
  }
  
  if (!API_CONFIG.AGENTFLOW.BASE_URL) {
    errors.push('REACT_APP_AGENTFLOW_API_BASE_URL is required');
  }
  
  if (!API_CONFIG.AGENTFLOW.FLOW_ID) {
    errors.push('REACT_APP_AGENTFLOW_FLOW_ID is required');
  }
  
  if (!API_CONFIG.AGENTFLOW.API_KEY) {
    errors.push('REACT_APP_AGENTFLOW_API_KEY is required');
  }
  
  if (errors.length > 0) {
    console.error('❌ Missing required environment variables:');
    errors.forEach(error => console.error(`  - ${error}`));
    console.error('\n📝 Please check your .env file and ensure all required variables are set.');
    return false;
  }
  
  return true;
};

// API Headers
export const getPangoHeaders = () => {
  if (!API_CONFIG.PANGO.API_KEY) {
    throw new Error('Pango API key is not configured');
  }
  
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${API_CONFIG.PANGO.API_KEY}`,
    'X-API-Key': API_CONFIG.PANGO.API_KEY
  };
};

export const getAgentFlowHeaders = () => {
  if (!API_CONFIG.AGENTFLOW.API_KEY) {
    throw new Error('AgentFlow API key is not configured');
  }
  
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${API_CONFIG.AGENTFLOW.API_KEY}`,
    'X-Model-Id': API_CONFIG.AGENTFLOW.FLOW_ID
  };
};

// API URLs
export const getPangoUrl = (endpoint: string) => {
  if (!API_CONFIG.PANGO.BASE_URL) {
    throw new Error('Pango API base URL is not configured');
  }
  
  const fullUrl = `${API_CONFIG.PANGO.BASE_URL}${endpoint}`;
  
  return fullUrl;
};

export const getAgentFlowUrl = () => {
  if (!API_CONFIG.AGENTFLOW.BASE_URL || !API_CONFIG.AGENTFLOW.FLOW_ID) {
    throw new Error('AgentFlow API configuration is incomplete');
  }
  
  // Base URL already includes the endpoint, just append flow ID
  return `${API_CONFIG.AGENTFLOW.BASE_URL}/${API_CONFIG.AGENTFLOW.FLOW_ID}`;
};
